import { GOOGLE_SHEETS_MIME_TYPE } from "@f2e/shared/constants"

import type { KnowledgeNodeSchema } from "@/hooks/api"

type TabularNodeLike = Pick<
  KnowledgeNodeSchema,
  | "name"
  | "node_type"
  | "content_type"
  | "status"
  | "snapshot_object_id"
  | "deleted_at"
>

export const isPotentialTabularKnowledgeNode = (
  node: TabularNodeLike | null | undefined
): boolean => {
  if (!node || node.node_type !== "FILE") return false
  const name = node.name.trim().toLowerCase()
  return (
    name.endsWith(".csv") ||
    name.endsWith(".xlsx") ||
    node.content_type === GOOGLE_SHEETS_MIME_TYPE
  )
}

export const isTabularReadyKnowledgeNode = (
  node: TabularNodeLike | null | undefined
): boolean =>
  isPotentialTabularKnowledgeNode(node) &&
  !node?.deleted_at &&
  node?.status === "READY" &&
  !!node.snapshot_object_id

export const getTabularSourceKind = (
  node: Pick<KnowledgeNodeSchema, "name" | "content_type">
): "csv" | "xlsx" | "googleSheet" | null => {
  if (node.content_type === GOOGLE_SHEETS_MIME_TYPE) return "googleSheet"
  const name = node.name.trim().toLowerCase()
  if (name.endsWith(".csv")) return "csv"
  if (name.endsWith(".xlsx")) return "xlsx"
  return null
}
